import { useEffect, useState } from 'react';
import { HMITemplate } from './types';
import { fetchHmiConfigurations } from './api';

export interface UseResolvedHmiTemplateResult {
  template: HMITemplate | undefined;
  loading: boolean;
}

/**
 * Resolves the HMI template configured for a given twin by calling the HMI
 * Configuration service directly (`GET .../twin/{twinId}`) and taking its
 * first entry - a twin owns at most one configuration document.
 */
export function useResolvedHmiTemplate(
  solutionId?: string,
  siteId?: string,
  twinId?: string
): UseResolvedHmiTemplateResult {
  const [template, setTemplate] = useState<HMITemplate | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!solutionId || !siteId || !twinId) {
      setTemplate(undefined);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    fetchHmiConfigurations(solutionId, siteId, twinId)
      .then((all) => {
        if (!cancelled) setTemplate(all[0]);
      })
      .catch(() => {
        if (!cancelled) setTemplate(undefined);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [solutionId, siteId, twinId]);

  return { template, loading };
}
